var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsTabSurveyInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5)",
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#AAAAAC",
    x: 15.923,
    y: 18.154,
    width: 40.154,
    height: 46.846,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 23.731,
    y: 30.423,
    width: 24.538,
    height: 6.692,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 23.731,
    y: 41.577,
    width: 17.846,
    height: 6.692,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 7c-5.544 0-10.038 3.859-10.038 8.619 0 1.4 1.321 2.535 2.952 2.535h14.172c1.63 0 2.952-1.135 2.952-2.535C46.038 10.859 41.544 7 36 7z",
    fill: "#828284"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTabSurveyInactive);
export default __webpack_public_path__ + "static/media/icons_tab_survey_inactive.e68954047cdab1d57d30e58b182e0ae6.svg";
export { ForwardRef as ReactComponent };